// src/locales/index.ts
import {createI18n} from 'vue-i18n';
import en from './en.json';
import zhCN from './zh-CN.json';

const i18n = createI18n({
    legacy: false, // 必须关闭传统模式以支持Composition API[8,11](@ref)
    locale: 'zh-CN', // 默认语言
    fallbackLocale: 'zh-CN', // 未找到翻译时回退
    messages: {
        'en': en,
        'zh-CN': zhCN,
    }
});

export default i18n;